import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {Typography} from '@material-ui/core';
import { ResultChart } from './';

const ResultAreaContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  margin: 16px;
  @media (max-width: 425px) {
    display: none;
  };
`;

const TabTitle = styled(Typography)`
  place-self: center
`;

function ResultArea(props) {
  const varCosts = props.variableCosts
  const fixedCosts = props.fixedCosts

  return (
    <ResultAreaContainer>
      <TabTitle variant="h4">Resultados</TabTitle>
      <ResultChart revenue={props.financialSetup.revenue} variableCosts={varCosts.number} fixedCosts={fixedCosts.number}/>
    </ResultAreaContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    financialSetup: state.reducers.financialSetup
  }
}

export default connect(
  mapStateToProps,
  null
)(ResultArea)
